module.exports = __webpack_public_path__ + "img/pattern1b.548696fe.png";